export type DocumentSubcategory =
  | 'customer-agreement-risk-disclosure'
  | 'general-information'
  | 'bonus-offer-terms'
  | 'policies-and-procedures'
  | 'forms';

export const DocumentSubcategoryTitle: { [k in DocumentSubcategory]: string } = {
  'customer-agreement-risk-disclosure': 'Customer Agreement and Risk Disclosure',
  'general-information': 'General Information',
  'bonus-offer-terms': 'Bonus Offer Terms',
  'policies-and-procedures': 'Policies and Procedures',
  forms: 'Forms',
};

export interface DocumentI {
  title: string;
  documentName?: string;
  document?: {
    url?: string;
    file?: {
      url?: string;
    };
  };
  details?: {
    documentType?: string;
    subcategory?: DocumentSubcategory;
    category?: string;
  };
}

export interface DocumentBlockI {
  documents: DocumentI[];
  categoryTitles: {
    title: DocumentSubcategory;
  }[];
}

export interface CategoryWithDocumentsI {
  title: DocumentSubcategory;
  docs: DocumentI[];
}
